// abbtxnerror

import { controls } from "../controls";


const abbtxnerror = {
  label: "ABB TXN",
  pageLabel: "ABB TXN",
  starting: true,
  url: "abbtxnerror",
  pageType: "history",
  formState: { checked: "view" },
  formActions: { edit: { allow: true }, delete: { allow: true } },
  form: [
    ...controls.displayText({ label: "ABB Transaction", width: "col-sm-12" }),
    ...controls.text({ name: "Name", width: "col-sm-2" })
  ],



}


export default abbtxnerror;